import { Dispatch } from 'react';
import { RepairFormState } from '../constants';
import { RepairFormActionMap } from '../reducer';
import { encryptId } from '@/helpers/encrypt-decrypt';
import logError from '@/helpers/logError';
import { getOrigin } from '@/helpers/getOrigin';

import {
	AssociateData,
	FinalizeHubspotDealResponse,
} from '@/helpers/hubspot/types';
import { getHubspotDeal } from './getHubspotDeal';
import { createNoteWithAttachmentAndAddToDeal } from './createNoteWithAttachmentAndAddToDeal';
import { getContact } from './getContact';

export async function finalizeHubspotDeal(
	state: RepairFormState,
	dispatch: Dispatch<RepairFormActionMap>,
): Promise<FinalizeHubspotDealResponse> {
	try {
		const hubspotDealId = await getHubspotDeal(state, dispatch);
		if (state.pictures.length > 0 && hubspotDealId) {
			await createNoteWithAttachmentAndAddToDeal(
				state,
				dispatch,
				hubspotDealId,
			);
		}
		const contact = await getContact(state, dispatch);
		if (contact && hubspotDealId) {
			const body: AssociateData = {
				fromObjectType: 'contact',
				fromObjectId: contact,
				toObjectType: 'deal',
				toObjectId: hubspotDealId,
				associationCategory: 'HUBSPOT_DEFINED',
				associationTypeId: 4,
			};

			await fetch(`/api/hubspot/associate`, {
				method: 'PUT',
				body: JSON.stringify(body),
			});
		}

		const encryptedId = encryptId(hubspotDealId || '');

		const uniqueUrl = new URL(
			`/replace/download/hs-${encryptedId}`,
			getOrigin(),
		).toString();

		// @TODO add back when ready HVAC3-2242
		// const leadPaymentUrl = `${constants.LEAD_PAYMENT_URL}${encryptedId}`;
		const leadPaymentUrl = '';

		return {
			success: true,
			dealInfo: { dealId: hubspotDealId || '', uniqueUrl, leadPaymentUrl },
		};
	} catch (error) {
		logError(
			error instanceof Error
				? error
				: new Error('An error occurred finalizing the deal'),
		);
		return { success: false };
	}
}
